import { render } from "./ChevronDown.vue?vue&type=template&id=e795f942"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ChevronDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e795f942"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e795f942', __exports__)) {
    api.reload('e795f942', __exports__)
  }
  
  module.hot.accept("./ChevronDown.vue?vue&type=template&id=e795f942", () => {
    api.rerender('e795f942', render)
  })

}


export default __exports__